//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilesField from '../../components/File/FilesField.vue'
import { createFilesGroupsMap } from './Request.js'
import { axiosGet } from '../../axios/axios.js'
import { convertReportFromServer } from '../Report/Report.js'
import { isImageDocument } from '../../components/File/FileUtils.js'
import FilesGroup from '../../components/File/FilesGroup.js'

export default {
  name: 'RequestReportsFilesSelector',
  components: {
    FilesField
  },
  props: {
    request: {
      type: Object,
      required: true
    },
    filesGroup: {
      type: FilesGroup,
      required: true
    },
    contentType: {
      type: String,
      default: null
    },
    callback: {
      type: Function,
      required: true
    }
  },
  data: function () {
    return {
      initialized: false,
      requestImagesFilesGroup: null,

      selectedReportDocuments: null,
      selectedReportFilesGroups: null,

      reportsDocuments: [],
      selectedFilesGroup: null
    }
  },
  computed: {
    imageContent: function () {
      return this.contentType === 'image'
    }
  },
  watch: {
    selectedReportDocuments: {
      handler: function () {
        if (this.selectedReportDocuments) {
          if (this.imageContent) {
            this.selectedReportFilesGroups = this.selectedReportDocuments.imageFilesGroups
          } else {
            this.selectedReportFilesGroups = this.selectedReportDocuments.docFilesGroups
          }

          this.selectedReportFilesGroups.forEach(selectedReportFilesGroup => {
            selectedReportFilesGroup.clearSelection()

            this.selectedFilesGroup.files.forEach(selectedFile => {
              const file = selectedReportFilesGroup.findFileById(selectedFile.id)
              if (file && !file.selected) {
                selectedReportFilesGroup.selectFile(file)
              }
            })
          })
        }
      },
      immediate: true
    }
  },
  created: function () {
    // const initiatorRequest = this.request.initiatorRequests[0]._srcObject
    // const initiatorRequestFilesGroupsMap = createFilesGroupsMap(initiatorRequest, true)
    // this.requestImagesFilesGroup = initiatorRequestFilesGroupsMap.images

    this.selectedFilesGroup = new FilesGroup({ categoryKey: 'selected', title: 'ВЫБРАННЫЕ ' + (this.imageContent ? 'ФОТОГРАФИИ' : 'ФАЙЛЫ'), readonly: false })
    this.filesGroup.files.forEach(fileWrapper => {
      if (fileWrapper.type === 'file' && fileWrapper.id != null) {
        this.selectedFilesGroup.pushFile(fileWrapper.document)
      }
    })

    this.load()
  },
  methods: {
    onApply () {
      const initialFilesGroup = this.filesGroup
      const initialFilesIds = initialFilesGroup.files
        .filter(fileWrapper => fileWrapper.type === 'file' && fileWrapper.id != null)
        .map(fileWrapper => fileWrapper.id)

      const resultFilesGroup = this.selectedFilesGroup
      const resultFilesIds = resultFilesGroup.files
        .filter(fileWrapper => fileWrapper.type === 'file' && fileWrapper.id != null)
        .map(fileWrapper => fileWrapper.id)

      const result = {
        filesGroup: resultFilesGroup,
        filesToAdd: [],
        filesToRemove: []
      }
      resultFilesGroup.files.forEach(fileWrapper => {
        if (!initialFilesIds.includes(fileWrapper.id)) {
          result.filesToAdd.push(fileWrapper)
        }
      })
      initialFilesGroup.files.forEach(fileWrapper => {
        if (!resultFilesIds.includes(fileWrapper.id)) {
          result.filesToRemove.push(fileWrapper)
        }
      })

      this.callback(result, true)
      this.$emit('cancel')
    },
    onCancel () {
      this.callback(null, false)
      this.$emit('cancel')
    },

    onRemoveFile: function ({ file: fileWrapper, filesGroup }) {
      if (fileWrapper.id != null) {
        filesGroup.deleteFile(fileWrapper)

        this.selectedReportFilesGroups.forEach(selectedReportFilesGroup => {
          const file = selectedReportFilesGroup.findFileById(fileWrapper.id)
          if (file && file.selected) {
            selectedReportFilesGroup.selectFile(file)
          }
        })
      }
    },
    selectOrDeleteImageFromReport: function (fileWrapper) {
      const selected = !this.selectedFilesGroup.containsFile(fileWrapper)
      if (selected) {
        // this.selectedFilesGroup.addFile(fileWrapper)
        this.selectedFilesGroup.pushFile(fileWrapper.document)
      } else {
        this.selectedFilesGroup.deleteFile(fileWrapper)
      }

      for (const selectedReportFilesGroup of this.selectedReportFilesGroups) {
        const file = selectedReportFilesGroup.findFileById(fileWrapper.id)
        if (file && file !== fileWrapper && file.selected !== selected) {
          selectedReportFilesGroup.selectFile(file)
        }
      }
    },

    // ======================

    load: function () {
      // const initiatorRequest = this.request.initiatorRequests[0]._srcObject
      // const requestId = initiatorRequest.requestId
      const requestId = this.request.initiatorRequests[0].id

      this.loading = true
      return this.loadTaskDocumentsList(requestId)
        .then((taskDocuments) => this.loadAndPrepareDataFromDocuments(taskDocuments))
        .then(taskData => {
          const request = taskData.request
          if (request) {
            if (this.imageContent) {
              this.requestImagesFilesGroup = request.filesGroupsMap.images
            } else {
              this.requestImagesFilesGroup = request.filesGroupsMap.docFiles
            }
          }

          for (const report of taskData.reports) {
            this.reportsDocuments.push(report) // TODO
          }
          if (this.reportsDocuments.length) {
            this.selectedReportDocuments = this.reportsDocuments[this.reportsDocuments.length - 1]
          }

          this.initialized = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadTaskDocumentsList: function (requestId) {
      return axiosGet({
        url: '/service/delta/request/documents?id=' + requestId,
        onSuccess: (response) => {
          return response.data.result.documents
        },
        onFailure: 'Ошибка загрузки документов по заданию'
      })
    },
    loadAndPrepareDataFromDocuments: function (taskDocuments) {
      const taskData = {
        allDocuments: taskDocuments,
        request: null,
        reports: []
      }

      const promises = []
      for (const taskDocument of taskDocuments) {
        if (taskDocument.type === 'request') {
          promises.push(this.loadRequestData(taskDocument.id).then(request => {
            request = this.prepareDataFromRequest(request)
            taskDocument.srcObject = request
            return taskDocument
          }))
        } else if (taskDocument.type === 'requestReport') {
          promises.push(this.loadReportData(taskDocument.id).then((report) => {
            report = this.prepareDataFromReport(report)
            taskDocument.srcObject = report
            return taskDocument
          }))
        }
      }

      return Promise.allSettled(promises).then(results => {
        results.forEach((result, num) => {
          if (result.status === 'rejected') {
            this.$q.notify({
              type: 'negative',
              message: result.message,
              progress: true,
              timeout: 8000
            })
          }
        })

        for (const taskDocument of taskDocuments) {
          if (taskDocument.srcObject) {
            if (taskDocument.type === 'request') {
              taskData.request = taskDocument.srcObject
            } else if (taskDocument.type === 'requestReport') {
              taskData.reports.push(taskDocument.srcObject)
            }
          }
        }
        return taskData
      })
    },
    loadRequestData: function (requestId) {
      return axiosGet({
        url: '/service/delta/request/getRequest?id=' + requestId,
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка загрузки данных заявки',
        throws: true
      })
    },
    prepareDataFromRequest: function (request) {
      request.filesGroupsMap = createFilesGroupsMap(request, true)
      return request
    },
    loadReportData: function (reportId) {
      return axiosGet({
        url: '/service/delta/report/' + reportId,
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка загрузки данных отчёта',
        throws: true
      })
    },
    prepareDataFromReport: function (report) {
      report = convertReportFromServer(report, this.$store.getters.getUser)

      const imageFilesGroups = []
      imageFilesGroups.push(new FilesGroup({ categoryKey: 'dispatcher', title: 'ФОТО ИЗ ЗАЯВКИ', readonly: true })) // !this.reportRoles.roleDispatcherOrHigher
      imageFilesGroups.push(new FilesGroup({ categoryKey: 'beforeWorkExecution', title: 'ДО ВЫПОЛНЕНИЯ РАБОТ', readonly: true }))
      imageFilesGroups.push(new FilesGroup({ categoryKey: 'duringWorkExecution', title: 'В ПРОЦЕССЕ ВЫПОЛНЕНИЯ РАБОТ', readonly: true }))
      imageFilesGroups.push(new FilesGroup({ categoryKey: 'afterWorkExecution', title: 'ПОСЛЕ ВЫПОЛНЕНИЯ РАБОТ', readonly: true }))
      imageFilesGroups.push(new FilesGroup({ categoryKey: 'forAuditRequest', title: 'ЗАМЕЧАНИЯ ПО АУДИТУ', readonly: true }))

      const imageFilesGroupsMap = {}
      imageFilesGroups.forEach(filesGroup => {
        imageFilesGroupsMap[filesGroup.key] = filesGroup
      })

      const docFilesGroups = []
      docFilesGroups.push(new FilesGroup({ categoryKey: 'dispatcher', title: 'ВЛОЖЕНИЯ ИЗ ЗАЯВКИ', readonly: true })) // !this.reportRoles.roleDispatcherOrHigher
      docFilesGroups.push(new FilesGroup({ categoryKey: 'afterWorkExecution', title: 'ПОСЛЕ ВЫПОЛНЕНИЯ РАБОТ', readonly: true }))

      const docFilesGroupsMap = {}
      docFilesGroups.forEach(filesGroup => {
        docFilesGroupsMap[filesGroup.key] = filesGroup
      })

      report.documents.forEach(document => {
        let filesGroup
        if (isImageDocument(document)) {
          filesGroup = imageFilesGroupsMap[document.category]
        } else {
          filesGroup = docFilesGroupsMap[document.category]
        }
        if (filesGroup) {
          filesGroup.pushFile(document)
        }
      })

      report.imageFilesGroups = imageFilesGroups
      report.docFilesGroups = docFilesGroups
      return report
    }
  }
}
